import React, { useState, useEffect } from "react";

export default // Filters Bar Component
function FiltersBar({ token, user, filters, setFilters }) {
  const [options, setOptions] = useState({
    districts: [],
    divisions: [],
    sectors: [],
    units: []
  });

  const fetchChildren = async (level, parentId) => {
    if (parentId === null) return;
    try {
      const res = await fetch(
        `https://smartcoreapi.ssfkerala.org/analytics/children.php?parent_id=${parentId}&level=${level}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const json = await res.json();
      if (Array.isArray(json)) {
        const mapped = json.map(item => ({ id: item.id, name: item.orgname }));
        if (level === 2) setOptions(prev => ({ ...prev, districts: mapped }));
        if (level === 3) setOptions(prev => ({ ...prev, divisions: mapped }));
        if (level === 4) setOptions(prev => ({ ...prev, sectors: mapped }));
        if (level === 5) setOptions(prev => ({ ...prev, units: mapped }));
      }
    } catch (err) {
      console.error("Failed to fetch children", err);
    }
  };

  useEffect(() => {
    if (user.role_id === 1) {
      fetchChildren(2, 1);
    } else if (user.role_id === 2) {
      setFilters(prev => ({ ...prev, district_id: user.id }));
      fetchChildren(3, user.id);
    } else if (user.role_id === 3) {
      setFilters(prev => ({ ...prev, division_id: user.id }));
      fetchChildren(4, user.id);
    } else if (user.role_id === 4) {
      setFilters(prev => ({ ...prev, sector_id: user.id }));
      fetchChildren(5, user.id);
    }
  }, [user]);

  const handleChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value || null }));

    if (key === "district_id") {
      setFilters(prev => ({ ...prev, division_id: null, sector_id: null, unit_id: null }));
      setOptions(prev => ({ ...prev, divisions: [], sectors: [], units: [] }));
      if (value) fetchChildren(3, value);
    }
    if (key === "division_id") {
      setFilters(prev => ({ ...prev, sector_id: null, unit_id: null }));
      setOptions(prev => ({ ...prev, sectors: [], units: [] }));
      if (value) fetchChildren(4, value);
    }
    if (key === "sector_id") {
      setFilters(prev => ({ ...prev, unit_id: null }));
      setOptions(prev => ({ ...prev, units: [] }));
      if (value) fetchChildren(5, value);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 mb-4 space-y-3">
      {user.role_id <= 1 && (
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">District</label>
          <select
            value={filters.district_id || ""}
            onChange={e => handleChange("district_id", e.target.value)}
            className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition outline-none"
          >
            <option value="">All Districts</option>
            {options.districts.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        </div>
      )}

      {user.role_id <= 2 && (
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Division</label>
          <select
            value={filters.division_id || ""}
            onChange={e => handleChange("division_id", e.target.value)}
            className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition outline-none"
          >
            <option value="">All Divisions</option>
            {options.divisions.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        </div>
      )}

      {user.role_id <= 3 && (
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Sector</label>
          <select
            value={filters.sector_id || ""}
            onChange={e => handleChange("sector_id", e.target.value)}
            className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition outline-none"
          >
            <option value="">All Sectors</option>
            {options.sectors.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
      )}

      {user.role_id <= 4 && (
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Unit</label>
          <select
            value={filters.unit_id || ""}
            onChange={e => handleChange("unit_id", e.target.value)}
            className="w-full px-3 py-2 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition outline-none"
          >
            <option value="">All Units</option>
            {options.units.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
        </div>
      )}
    </div>
  );
}